import { combineReducers } from 'redux';
import { marketPriceReducer } from 'redux/marketPrice';
import { companyJobsReducer } from './companyJobs';
import { mappingReducer } from './mapping';
import { userReducer } from './user';
import { notificationsReducer } from './notifications';
import { dataManagementReducer } from './dataManagement';

const rootReducer = combineReducers({
  user: userReducer,
  marketPrice: marketPriceReducer,
  companyJobs: companyJobsReducer,
  mapping: mappingReducer,
  notifications: notificationsReducer,
  dataManagement: dataManagementReducer,
});

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer;
